import { FormObjType } from "DataTypes/Form";

export const EditForm: FormObjType[] = [
  {
    id: "firstName",
    label: "First Name",
    placeholder: "Enter First Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "middleName",
    label: "Middle Name",
    placeholder: "Enter Middle Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    enableFormLoad: false,
  },
  {
    id: "lastName",
    label: "Last Name",
    placeholder: "Enter Last Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "dob",
    label: "Date Of Birth",
    placeholder: "Select Date Of Birth",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    required: true,
    enableFormLoad: true
  },
  {
    id: "home",
    label: "Home Number",
    placeholder: "Enter Home Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "mobile no.",
    required: false,
    enableFormLoad: true,
  },
  {
    id: "mobile",
    label: "Mobile Number",
    placeholder: "Enter Mobile Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "mobile no.",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "email",
    label: "Email Id",
    placeholder: "Enter Email Id",
    boxType: "input",
    boxSize: 3,
    validatetype: "email",
    required: false,
    enableFormLoad: true,
  },
  {
    id: "language",
    label: "Language",
    placeholder: "Enter Language",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: false,
    enableFormLoad: true
  },
  {
    id: "streetAddress",
    label: "Address 1",
    placeholder: "Enter Street Address",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "address2",
    label: "Address 2",
    placeholder: "Enter Street Address",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: false,
    enableFormLoad: true,
  },
  {
    id: "city",
    label: "City",
    placeholder: "Enter City",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "state",
    label: "State",
    placeholder: "Enter State",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "zip",
    label: "Zipcode",
    placeholder: "Enter Zipcode",
    boxType: "input",
    boxSize: 3,
    validatetype: "zipcode",
    required: true,
    enableFormLoad: true,
  },
];

